import cn from 'classnames'
import { useTabsSelectSaleAnalytics } from '../TabsSelectSaleAnalytics'

interface TabBodyProps {
  children: React.ReactNode
  tabId: string
}

export function TabBody({ tabId, children }: TabBodyProps) {
  const { activeTab } = useTabsSelectSaleAnalytics()

  return activeTab === tabId ? <div>{children}</div> : null
}
